import { Box, Chip, Divider, Grid2, Typography } from '@mui/material';

export function CatalogueItemBidHistoryBox(params: { submittedBid: string; placedBids: string[] }) {
    return (
        <Grid2 size={{ xs: 12 }}>
            <Box sx={{ mt: 1, p: 1.5, border: '1px solid', borderColor: 'divider', borderRadius: 1, bgcolor: 'background.paper' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Typography variant="subtitle2" sx={{ color: 'text.secondary', textTransform: 'uppercase', letterSpacing: 0.5 }}>
                        Current bid
                    </Typography>
                    <Chip label={`€${params.submittedBid}`} color="primary" size="small" sx={{ fontWeight: 700 }} />
                </Box>

                {params.placedBids.length > 0 &&
                    <>
                        <Divider sx={{ my: 1 }} />
                        <Typography variant="caption" sx={{ color: 'text.secondary', textTransform: 'uppercase', letterSpacing: 0.5 }}>
                            Bids placed
                        </Typography>
                        <Box sx={{ mt: 0.5, display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                            {params.placedBids.map((b, i) => (
                                <Box key={i} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <Typography variant="body2" sx={{ color: i === 0 ? 'text.primary' : 'text.secondary', fontWeight: i === 0 ? 600 : 400 }}>
                                        {i === 0 ? 'Latest' : 'Previous'}
                                    </Typography>
                                    <Chip label={`€${b}`} color="success" size="small" variant={i === 0 ? 'filled' : 'outlined'} sx={{ fontWeight: 600 }} />
                                </Box>
                            ))}
                        </Box>
                    </>
                }
            </Box>
        </Grid2>
    );
}
